// extracted by mini-css-extract-plugin
module.exports = {"usizy-component":"Usizy_usizy-component__cn3fV","usizy-disabled":"Usizy_usizy-disabled__G1Qth","icon":"Usizy_icon__QSFoQ","size-guide-wrapper":"Usizy_size-guide-wrapper__3_DNH"};